import Details from './Details'
import Preview from './Preview'

export default {
  Details,
  Preview
}
